import { mixpanel, traffic2 } from '../../utils/buildAnalyticsEvents';

/* NOTE: All events below was modify to have impression at the end instead vistited.
 * For instance: marketing.root.visited was change to marketing.root.impression
 */

export const ROUTES_EVENTS = {
  ROOT_VISITED: {
    ...mixpanel('GUM Root Visited'),
    ...traffic2('marketing.root.impression')
  },
  SETTINGS_VISITED: {
    ...mixpanel('GUM Settings Visited'),
    ...traffic2('marketing.settings.impression')
  },
  WEBSITE_ROOT_VISITED: {
    ...mixpanel('GUM Website Root Visited'),
    ...traffic2('marketing.website.root.impression')
  },
  DASHBOARD_VISITED: {
    ...mixpanel('GUM Dashboard Visited'),
    ...traffic2('marketing.dashboard.impression')
  },
  GUM_OPENED: {
    ...mixpanel('GUM Marketing Impression'),
    ...traffic2('marketing.open.impression')
  },
  STATS_VISITED: {
    ...mixpanel('GUM Stats Page Shown'),
    ...traffic2('marketing.stats_page.impression')
  },
  OVERVIEW_TAB_VISITED: {
    ...mixpanel('GUM Overview Tab Visited'),
    ...traffic2('marketing.overview_tab.impression')
  },
  CAMPAIGNS_TAB_VISITED: {
    ...mixpanel('GUM Campaigns Tab Visited'),
    ...traffic2('marketing.campaigns_tab.impression')
  },
  SETTINGS_TAB_VISITED: {
    ...mixpanel('GUM Settings Tab Visited'),
    ...traffic2('marketing.settings_tab.impression')
  }
};
